<template>
  <DeepDialog
    v-model="show"
    :title="t('live_status.title')"
    max-width="1200"
    card-text-cls="px-2 py-1 d-flex flex-column"
    height-content="100dvh"
  >
    <template #content>
      <v-tabs v-model="tab">
        <v-tab
          v-for="source in sources"
          :key="source.key"
          :value="source.key"
          :text="source.label"
        >
          <template #prepend>
            <LiveStatusIcon :status="statusBySource[source.key]" size="small" />
          </template>
        </v-tab>
      </v-tabs>
      <iframe
        v-for="source in sources"
        v-show="tab === source.key"
        :key="source.key"
        :src="source.pageUrl"
        :title="source.label"
        class="live-status-frame flex-1-1 w-100 border-0 mt-4"
      ></iframe>
    </template>
    <template #actions>
      <v-btn-secondary @click="show = false">
        {{ t('actions.close') }}
      </v-btn-secondary>
    </template>
  </DeepDialog>
</template>

<script setup lang="ts">
import { DeepDialog } from '@deepcloud/deep-ui-lib'
import { LIVE_STATUS_URLS, useLiveStatus } from '@/composables/use-live-status'
import LiveStatusIcon from './LiveStatusIcon.vue'
import type { LiveStatusSourceKey } from '@/composables/use-live-status'

const { t } = useI18n()
const { statusBySource, refresh } = useLiveStatus()

const show = defineModel<boolean>()

const sources: { key: LiveStatusSourceKey; label: string; pageUrl: string }[] =
  [
    {
      key: 'abaservices',
      label: 'AbaServices',
      pageUrl: `${LIVE_STATUS_URLS.abaservices}?theme=light`,
    },
    {
      key: 'deepcloud',
      label: 'DeepCloud',
      pageUrl: `${LIVE_STATUS_URLS.deepcloud}?theme=light`,
    },
  ]

const tab = ref<LiveStatusSourceKey>('abaservices')

watch(show, (isOpen) => {
  if (isOpen) refresh()
})
</script>

<style scoped>
.live-status-frame {
  min-height: 0;
}
</style>
